import type { CampaignCreativeRollout } from '@/api/types';

/**
 * The newest rollout per creative slot, from a plan's journal (newest first).
 * A slot with none is simply absent; the badge reads absence as "nothing in
 * flight, nothing failed".
 */
export function slotRollouts(
  plan: { creative_rollouts?: CampaignCreativeRollout[] } | undefined,
): Map<number, CampaignCreativeRollout> {
  const out = new Map<number, CampaignCreativeRollout>();
  for (const rollout of plan?.creative_rollouts ?? []) {
    if (!out.has(rollout.position)) out.set(rollout.position, rollout);
  }
  return out;
}
